import * as Reflux from "reflux";
export const CustomerCartPageActions = {
	checkOut: Reflux.createAction(["checkOut"]),
	oneClickSubmit: Reflux.createAction(["oneClickSubmit"]),
	printCart: Reflux.createAction(["printCart"]),
	updateItemsFilter: Reflux.createAction(["updateItemsFilter"]),
	changeSortCriterion: Reflux.createAction(["changeSortCriterion"]),
	showTOSWarning: Reflux.createAction(["showTOSWarning"]),
};
